module.exports = __webpack_public_path__ + "static/media/7. Get notified and take action.c52b7f00.svg";